// 이름 정리 함수 (날짜 suffix 제거)
export const cleanName = (name) => {
  if (!name) return name;
  return name.replace(/_\d{4}-\d{2}-\d{2}$/g, '').trim();
};

// 실제 데이터 존재 여부 확인
export const checkHasRealData = (resumeData) => ({
  name: !!resumeData.name,
  title: !!resumeData.title,
  phone: !!resumeData.phone,
  email: !!resumeData.email,
  github: !!resumeData.github,
  address: !!resumeData.address,
  summary: !!resumeData.summary,
  keyStrengths: resumeData.keyStrengths && resumeData.keyStrengths.length > 0,
  experiences: resumeData.experiences && resumeData.experiences.length > 0,
  education: resumeData.education && resumeData.education.length > 0,
  skills: resumeData.skills && resumeData.skills.length > 0,
  certificates: resumeData.certificates && resumeData.certificates.length > 0,
  papers: resumeData.papers && resumeData.papers.length > 0,
  socialLinks: resumeData.social_links && resumeData.social_links.length > 0
});

// 현재 데이터 가져오기 (실제 데이터 없으면 placeholder 사용)
export const getCurrentData = (resumeData, placeholderData, hasRealData) => ({
  name: cleanName(resumeData.name) || cleanName(placeholderData.name),
  title: resumeData.title || placeholderData.title,
  phone: resumeData.phone || placeholderData.phone,
  email: resumeData.email || placeholderData.email,
  github: resumeData.github || placeholderData.github,
  address: resumeData.address || placeholderData.address,
  summary: resumeData.summary || placeholderData.summary,
  keyStrengths: hasRealData.keyStrengths ? resumeData.keyStrengths : placeholderData.keyStrengths,
  experiences: hasRealData.experiences ? resumeData.experiences : placeholderData.experiences,
  education: hasRealData.education ? resumeData.education : placeholderData.education,
  skills: hasRealData.skills ? resumeData.skills : placeholderData.skills,
  certificates: hasRealData.certificates ? resumeData.certificates : placeholderData.certificates,
  papers: resumeData.papers || [],
  socialLinks: resumeData.social_links || []
});

// 논문 타입 텍스트 가져오기
export const getPaperTypeText = (type) => {
  const typeMap = {
    'journal': '학술지 논문',
    'conference': '학회 발표',
    'preprint': '프리프린트',
    'book': '도서/챕터',
    'patent': '특허'
  };
  return typeMap[type] || type;
};

// 필드 업데이트 중인지 확인
export const isFieldUpdating = (field, updatingField) => updatingField === field;

// 볼드 텍스트 파싱 (Template1에서 사용)
export const parseBoldText = (text) => {
  if (!text || typeof text !== 'string') return text;
  const parts = text.split('**');
  return (
    <>
      {parts.map((part, index) =>
        index % 2 === 1 ? <strong key={index} className="font-semibold text-gray-800">{part}</strong> : part
      )}
    </>
  );
};


